import type { FaireProductEntity } from "../../entity_types/product";

export const p_9prbz7fghz: FaireProductEntity = {
  token: "p_9prbz7fghz",
  type: "product",
  name: "Candied Almonds, 4.0 oz.",
  brandToken: "b_f0wtyxk4dn",
  brandName: "Chesebro's Handmade Confections and Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/7b184a7fbc56db2ee3573367a0e576c08c9dc6f2774e612017490da6cc75b867.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e165b071ff17363f24e504eb85785b109216f8567903fed372d231716d7bf1fe.png",
  ],
  priceDollars: 5.54,
  description:
    "We slow roast each batch of our almonds with just the right amount of sugar, cinnamon and vanilla to make the perfect snackable treat! Each 4 ounce bag is carefully packaged by hand to ensure the best possible quality.\n\nThese delectable nuts have so many great uses:\n\nEat them right our of the bag!\nAdd them to a salad as a gourmet topping with just the right amount of crunch!\nFeeling adventurous? Mix them with other yummies in a homemade trail mix!\nYams and sweet potatoes - sprinkle them on top of baked, mashed or a casserole!\nOur candy is cooked in a copper kettle with top quality ingredients before being formed by vintage equipment. We're proud to say our candies are family made in the USA!\n\nManufactured in a facility that processes tree nuts, peanuts, dairy and soy products. Do not eat if you have allergies to these products.",
  tags: [],
  msrpDollars: 11.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:02.934Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
